import iconUsersSelected from "../menu/users-selected.svg";
import iconUsersNotSelected from "../menu/users-not-selected.svg";
import iconEventsSelected from "../menu/events-selected.svg";
import iconEventsNotSelected from "../menu/events-not-selected.svg";
import iconSellersSelected from "../menu/sellers-selected.svg";
import iconSellersNotSelected from "../menu/sellers-not-selected.svg";
import iconPermissionsSelected from "../menu/permissions-selected.svg";
import iconPermissionsNotSelected from "../menu/permissions-not-selected.svg";
import iconAccountSelected from "../menu/account-selected.svg";
import iconAccountNotSelected from "../menu/account-not-selected.svg";

export interface MenuItemProps {
  icon: string;
  iconSelected: string;
  label: string;
  path: string;
  position: "top" | "bottom";
  role?: string[];
}

export const menuListItems: MenuItemProps[] = [
  {
    icon: iconUsersNotSelected,
    iconSelected: iconUsersSelected,
    label: "Usuários",
    path: "/home",
    position: "top",
    role: ["ADMIN"],
  },
  {
    icon: iconEventsNotSelected,
    iconSelected: iconEventsSelected,
    label: "Eventos",
    path: "/events",
    position: "top",
    role: ["ADMIN", "EVENTOS"],
  },
  {
    icon: iconSellersNotSelected,
    iconSelected: iconSellersSelected,
    label: "Varejistas",
    path: "/sellers",
    position: "top",
    role: ["ADMIN"],
  },
  {
    icon: iconSellersNotSelected,
    iconSelected: iconSellersSelected,
    label: "Loja Confi",
    path: "/internal-store",
    position: "top",
    role: ["ADMIN"],
  },
  {
    icon: iconUsersNotSelected,
    iconSelected: iconUsersSelected,
    label: "Exclusão de contas",
    path: "/account-deletions",
    position: "top",
    role: ["ADMIN"],
  },
  {
    icon: iconEventsNotSelected,
    iconSelected: iconEventsSelected,
    label: "Ingressos de parceiros",
    path: "/ticket-ingestions",
    position: "top",
    role: ["ADMIN"],
  },
  {
    icon: iconPermissionsNotSelected,
    iconSelected: iconPermissionsSelected,
    label: "Permissões",
    path: "/permissions",
    position: "bottom",
    role: ["ADMIN"],
  },
  {
    icon: iconAccountNotSelected,
    iconSelected: iconAccountSelected,
    label: "Minha conta",
    path: `/account`,
    position: "bottom",
    role: ["ADMIN", "EVENTOS"],
  },
];
